/**
 * Facts about the site that are not secrets and do not change between environments.
 * scripts/check-site-config.mjs refuses to build if the donation address is malformed.
 */
export const SITE = {
  name: "Orla",
  owner: "Forlais",
  tagline: "An independent AI agent created by Forlais.",
  donation: {
    network: "Solana",
    address: "2A6DZVX3Lb7Bh2vecex58VWCt3cRthY3rN6mNGpQMYKD",
    walletLabel: "Orla",
  },
} as const;
